"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configure = configure;
exports.getConfig = exports.DURATION = void 0;

var _oxygenConstants = require("@8x8/oxygen-constants");

var _pubsubJs = _interopRequireDefault(require("pubsub-js"));

var _closeAll = _interopRequireDefault(require("./close-all"));

var events = _interopRequireWildcard(require("./constants/events"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DEFAULT_CONFIG = {
  targetNode: document.body,
  size: _oxygenConstants.toastSizes.medium,
  duration: 5000,
  stackSize: 4
};
var config = DEFAULT_CONFIG;
var DURATION = {
  INFINITE: Infinity
};
/**
 * @param {Object} options
 * @param {HTMLElement} [options.targetNode=document.body]
 * @param {String} [options.size=medium]
 * @param {Number} [options.duration=5]
 * @param {Number} [options.stackSize=4]
 */

exports.DURATION = DURATION;

function configure(options) {
  (0, _closeAll["default"])();
  config = Object.assign({}, DEFAULT_CONFIG, options);

  _pubsubJs["default"].publish(events.CONFIG_UPDATE);
}

var getConfig = function getConfig() {
  return config;
};

exports.getConfig = getConfig;